import InterfaceAsesmenRisikoJatuh from "../apiInterface/InterfaceAsesmenRisikoJatuh";
import ErrorAlert from "@/utility/ErrorAlert";
import InterfaceSkriningRisikoJatuh from "@/apiInterface/InterfaceSkriningRisikoJatuh";

class DataSkriningRisikoJatuh {
  async getDataAsesmenRisikoJatuh(unit, reg) {
    let dt: any;
    await InterfaceSkriningRisikoJatuh.getSkriningRisikoJatuh(unit, reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Skrining Risiko Jatuh");
      });
    return dt;
  }
  async getDataSkriningRisikoJatuhByReg(unit, reg) {
    let dt: any;
    await InterfaceSkriningRisikoJatuh.getSkriningRisikoJatuhByReg(unit, reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Skrining Risiko Jatuh by Register");
      });
    return dt;
  }
  async getDataSkriningRisikoJatuhByRm(rm) {
    let dt: any;
    await InterfaceSkriningRisikoJatuh.getSkriningRisikoJatuhByRm(rm)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Skrining Risiko Jatuh by Register");
      });
    return dt;
  }

  async saveDataSkriningRisikoJatuh(reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id) {
    let dt: object = {};
    await InterfaceSkriningRisikoJatuh.saveSkriningRisikoJatuh(reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataSkriningRisikoJatuh(id, reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id) {
    let dt: object = {};
    await InterfaceSkriningRisikoJatuh.editSkriningRisikoJatuh(id, reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
}

export default new DataSkriningRisikoJatuh();
